import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7cdc372"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-section" }
const _hoisted_2 = {
  htmlFor: "upload-img",
  for: "upload-img",
  class: "tabs-actions btn btn-secondary upload-btn"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add Image ")
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_list_complete = _resolveComponent("list-complete")!
  const _component_edit_image_modal = _resolveComponent("edit-image-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _createVNode(_component_fa, { icon: "upload" }),
        _hoisted_3,
        _createElementVNode("input", {
          type: "file",
          accept: "image/*",
          class: "upload-img",
          name: "upload-img",
          id: "upload-img",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setImage && _ctx.setImage(...args)))
        }, null, 32)
      ]),
      (_ctx.store?.images?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_list_complete, {
              files: _ctx.store.images,
              onDeleteItem: _ctx.removeFile
            }, null, 8, ["files", "onDeleteItem"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeTab('prev'))),
        class: "tabs-actions btn btn-secondary"
      }, "Prev"),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeTab('next'))),
        class: "tabs-actions btn btn-secondary"
      }, "Next")
    ]),
    _createVNode(_component_edit_image_modal, {
      openModal: _ctx.openModal,
      file: _ctx.currentFile,
      onSetModal: _ctx.closeModal,
      onImageUploaded: _ctx.imageUploaded
    }, null, 8, ["openModal", "file", "onSetModal", "onImageUploaded"])
  ]))
}